import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogFooter,
} from "../ui/Alert-dialog";
import { Button } from "../ui/Button";
import { cn } from "../../lib/cn";

export function AlertBox({
    open,
    onOpenChange,
    title = "Alert",
    description = null,
    content = null,
    actions = [],
    onAction = () => { },
    className = "",
}) {
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent
                className={cn(
                    "w-[90%] rounded-[5px] p-3 shadow-lg",
                    className
                )}
            >
                <AlertDialogHeader className="text-left gap-1">
                    <AlertDialogTitle className="text-[22px] font-semibold text-text-primary">
                        {title}
                    </AlertDialogTitle>

                    {description && (
                        <AlertDialogDescription className="text-[14px] text-text-primary mt-1" asChild>
                            <div>{description}</div>
                        </AlertDialogDescription>
                    )}

                    {content && (
                        <div className="text-sm text-text-primary grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 !mt-4">{content}</div>
                    )}
                </AlertDialogHeader>

                {/* Desktop Layout - Flex with auto width */}
                <AlertDialogFooter className="hidden sm:flex sm:flex-row sm:justify-start gap-3 mt-1">
                    {actions
                        .slice()
                        .reverse()
                        .map((action, index) => {
                            const buttonVariant = action.variant === "cancel" ? "secondary" : "primary";

                            return (
                                <Button
                                    key={index}
                                    variant={buttonVariant}
                                    size="sm"
                                    className={cn(action.className)}
                                    onClick={() => {
                                        onAction(action.value);
                                        onOpenChange(false);
                                    }}
                                >
                                    {action.icon && <span>{action.icon}</span>}
                                    {action.label}
                                </Button>
                            );
                        })}
                </AlertDialogFooter>

                {/* Mobile Layout - Flex column, reversed order */}
                {/* Mobile Layout - Flex row, reversed order */}
                <AlertDialogFooter className="flex sm:hidden flex-row justify-start gap-3 md:mt-4">
                    {actions
                        .slice()
                        .reverse()
                        .map((action, index) => {
                            const buttonVariant = action.variant === "cancel" ? "secondary" : "primary";

                            return (
                                <Button
                                    key={index}
                                    variant={buttonVariant}
                                    size="sm"
                                    className={cn(action.className)}
                                    onClick={() => {
                                        onAction(action.value);
                                        onOpenChange(false);
                                    }}
                                >
                                    {action.icon && <span>{action.icon}</span>}
                                    {action.label}
                                </Button>
                            );
                        })}
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}